<template>
    <v-dialog
        v-model="dialog_show_active"
        persistent max-width="500px"
    >
        <v-card>
            <v-toolbar dark color="error">
                <v-toolbar-title class="headline">
                    {{$t('blocked_service')}}
                </v-toolbar-title>
            </v-toolbar>
            <v-card-title class="headline">
            </v-card-title>
            <v-card-text class="text-justify">
                <p>
                    {{$t('dear_user')}}<br> <br>
                    {{$t('msg_blocked_service_01')}}<br><br>
                    {{$t('msg_blocked_service_02')}}<br>
                </p>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="black" outlined @click="$store.commit('dialog_show_active_false')">{{$t('aceptar')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'dialog_show',
  computed: {
    dialog_show_active: {
      get () {
        return this.$store.state.dialog_show_active
      },
      set () {
      }
    }
  }
}
</script>

<style scoped>
    .sizeMessage{
        font-size: 130%;
    }
</style>
